// Vietnamese phrases

export default {
  com_ui_examples: 'Ví dụ',
  com_ui_new_chat: 'Trò chuyện mới',
  com_ui_happy_birthday: 'Đây là sinh nhật đầu tiên của tôi!',
  com_ui_example_quantum_computing: 'Giải thích máy tính lượng tử theo cách đơn giản',
  com_ui_example_10_year_old_b_day:
    'Có ý tưởng sáng tạo nào cho sinh nhật của một đứa trẻ 10 tuổi không?',
  com_ui_example_http_in_js: 'Làm thế nào để thực hiện yêu cầu HTTP trong Javascript?',
  com_ui_capabilities: 'Khả năng',
  com_ui_capability_remember: 'Ghi nhớ những gì người dùng nói trước đó trong cuộc trò chuyện',
  com_ui_capability_correction: 'Cho phép người dùng cung cấp sự sửa đổi tiếp theo',
  com_ui_capability_decline_requests: 'Được đào tạo để từ chối các yêu cầu không thích hợp',
  com_ui_limitations: 'Hạn chế',
  com_ui_limitation_incorrect_info: 'Có thể đôi khi tạo ra thông tin không chính xác',
  com_ui_limitation_harmful_biased:
    'Có thể đôi khi tạo ra hướng dẫn gây hại hoặc nội dung thiên vị',
  com_ui_limitation_limited_2021: 'Kiến thức hạn chế về thế giới và sự kiện sau năm 2021',
  com_ui_input: 'Đầu vào',
  com_ui_close: 'Đóng',
  com_ui_model: 'Mô hình',
  com_ui_select_model: 'Chọn một mô hình',
  com_ui_use_prompt: 'Sử dụng gợi ý',
  com_ui_prev: 'Trước',
  com_ui_next: 'Tiếp theo',
  com_ui_prompt_templates: 'Mẫu gợi ý',
  com_ui_hide_prompt_templates: 'Ẩn mẫu gợi ý',
  com_ui_showing: 'Hiển thị',
  com_ui_of: 'của',
  com_ui_entries: 'mục',
  com_ui_pay_per_call:
    'Tất cả các cuộc hội thoại AI ở một nơi. Trả tiền cho mỗi cuộc gọi chứ không phải mỗi tháng',
  com_ui_enter: 'Nhập',
  com_ui_submit: 'Gửi',
  com_ui_upload_success: 'Tải tệp thành công',
  com_ui_cancel: 'Hủy',
  com_ui_save: 'Lưu',
  com_ui_copy_to_clipboard: 'Sao chép vào clipboard',
  com_ui_copied_to_clipboard: 'Đã sao chép vào clipboard',
  com_ui_regenerate: 'Tạo lại',
  com_ui_continue: 'Tiếp tục',
  com_ui_edit: 'Sửa',
  com_ui_success: 'Thành công',
  com_ui_all: 'tất cả',
  com_ui_clear: 'Xóa',
  com_ui_revoke: 'Hủy bỏ',
  com_ui_revoke_info: 'Hủy bỏ tất cả các thông tin xác thực được cung cấp bởi người dùng.',
  com_ui_import_conversation: 'Nhập khẩu',
  com_ui_import_conversation_info: 'Nhập khẩu cuộc trò chuyện từ một tệp JSON',
  com_ui_import_conversation_success: 'Đã nhập khẩu cuộc trò chuyện thành công',
  com_ui_import_conversation_error: 'Đã xảy ra lỗi khi nhập khẩu cuộc trò chuyện của bạn',
  com_ui_confirm_action: 'Xác nhận hành động',
  com_ui_chats: 'cuộc trò chuyện',
  com_ui_share: 'Chia sẻ',
  com_ui_copy_link: 'Sao chép liên kết',
  com_ui_update_link: 'Cập nhật liên kết',
  com_ui_create_link: 'Tạo liên kết',
  com_ui_share_link_to_chat: 'Chia sẻ liên kết đến cuộc trò chuyện',
  com_ui_share_error: 'Có lỗi xảy ra khi chia sẻ liên kết trò chuyện',
  com_ui_share_retrieve_error: 'Đã xảy ra lỗi khi xóa liên kết được chia sẻ.',
  com_ui_share_delete_error: 'Đã xảy ra lỗi khi xóa liên kết được chia sẻ.',
  com_ui_share_create_message:
    'Tên của bạn và bất kỳ tin nhắn nào bạn thêm sau khi chia sẻ sẽ được giữ kín.',
  com_ui_share_created_message:
    'Liên kết chia sẻ đến cuộc trò chuyện của bạn đã được tạo. Quản lý các cuộc trò chuyện đã chia sẻ trước đây bất cứ lúc nào thông qua Cài đặt.',
  com_ui_share_update_message:
    'Tên của bạn, hướng dẫn tùy chỉnh và bất kỳ tin nhắn nào bạn thêm sau khi chia sẻ sẽ được giữ kín.',
  com_ui_share_updated_message:
    'Liên kết chia sẻ đến cuộc trò chuyện của bạn đã được cập nhật. Quản lý các cuộc trò chuyện đã chia sẻ trước đây bất cứ lúc nào thông qua Cài đặt.',
  com_ui_shared_link_not_found: 'Không tìm thấy liên kết chia sẻ',
  com_ui_delete: 'Xóa',
  com_ui_delete_conversation: 'Xóa cuộc trò chuyện?',
  com_ui_delete_confirm: 'Điều này sẽ xóa',
  com_ui_rename: 'Đổi tên',
  com_ui_archive: 'Lưu trữ',
  com_ui_archive_error: 'Không thể lưu trữ cuộc trò chuyện',
  com_ui_unarchive: 'Bỏ lưu trữ',
  com_ui_unarchive_error: 'Không thể bỏ lưu trữ cuộc trò chuyện',
  com_ui_more_options: 'Thêm',
  com_ui_bookmarks: 'Dấu trang',
  com_ui_bookmarks_rebuild: 'Xây dựng lại',
  com_ui_bookmarks_new: 'Dấu trang mới',
  com_ui_bookmark_delete_confirm: 'Bạn có chắc chắn muốn xóa dấu trang này không?',
  com_ui_bookmarks_title: 'Tiêu đề',
  com_ui_bookmarks_count: 'Số lượng',
  com_ui_bookmarks_description: 'Mô tả',
  com_ui_bookmarks_create_success: 'Tạo dấu trang thành công',
  com_ui_bookmarks_update_success: 'Cập nhật dấu trang thành công',
  com_ui_bookmarks_delete_success: 'Xóa dấu trang thành công',
  com_ui_bookmarks_create_error: 'Có lỗi xảy ra khi tạo dấu trang',
  com_ui_bookmarks_update_error: 'Có lỗi xảy ra khi cập nhật dấu trang',
  com_ui_bookmarks_delete_error: 'Có lỗi xảy ra khi x��a dấu trang',
  com_ui_bookmarks_add_to_conversation: 'Thêm vào cuộc hội thoại hiện tại',
  com_ui_accept: 'Tôi chấp nhận',
  com_ui_decline: 'Tôi không chấp nhận',
  com_ui_terms_and_conditions: 'Điều khoản và điều kiện',
  com_ui_no_terms_content: 'Không có nội dung điều khoản và điều kiện để hiển thị',
  com_auth_error_login:
    'Không thể đăng nhập với thông tin được cung cấp. Vui lòng kiểm tra thông tin đăng nhập và thử lại.',
  com_auth_error_login_rl:
    'Quá nhiều lần đăng nhập trong một khoảng thời gian ngắn. Vui lòng thử lại sau.',
  com_auth_error_login_ban:
    'Tài khoản của bạn đã bị khóa tạm thời do vi phạm dịch vụ của chúng tôi.',
  com_auth_error_login_server:
    'Đã xảy ra lỗi máy chủ nội bộ. Vui lòng đợi một vài phút và thử lại.',
  com_auth_no_account: 'Chưa có tài khoản?',
  com_auth_sign_up: 'Đăng ký',
  com_auth_sign_in: 'Đăng nhập',
  com_auth_google_login: 'Đăng nhập bằng Google',
  com_auth_facebook_login: 'Đăng nhập bằng Facebook',
  com_auth_github_login: 'Đăng nhập bằng Github',
  com_auth_discord_login: 'Đăng nhập bằng Discord',
  com_auth_email: 'Email',
  com_auth_email_required: 'Email là bắt buộc',
  com_auth_email_min_length: 'Email phải có ít nhất 6 ký tự',
  com_auth_email_max_length: 'Email không được dài hơn 120 ký tự',
  com_auth_email_pattern: 'Bạn phải nhập địa chỉ email hợp lệ',
  com_auth_email_address: 'Địa chỉ email',
  com_auth_password: 'Mật khẩu',
  com_auth_password_required: 'Mật khẩu là bắt buộc',
  com_auth_password_min_length: 'Mật khẩu phải có ít nhất 8 ký tự',
  com_auth_password_max_length: 'Mật khẩu phải ít hơn 128 ký tự',
  com_auth_password_forgot: 'Quên mật khẩu?',
  com_auth_password_confirm: 'Xác nhận mật khẩu',
  com_auth_password_not_match: 'Mật khẩu không khớp',
  com_auth_continue: 'Tiếp tục',
  com_auth_create_account: 'Tạo tài khoản của bạn',
  com_auth_error_create: 'Có lỗi khi đăng ký tài khoản của bạn. Vui lòng thử lại.',
  com_auth_full_name: 'Họ và tên đầy đủ',
  com_auth_name_required: 'Tên là bắt buộc',
  com_auth_name_min_length: 'Tên phải có ít nhất 3 ký tự',
  com_auth_name_max_length: 'Tên phải ít hơn 80 ký tự',
  com_auth_username: 'Tên người dùng (tùy chọn)',
  com_auth_username_required: 'Tên người dùng là bắt buộc',
  com_auth_username_min_length: 'Tên người dùng phải có ít nhất 2 ký tự',
  com_auth_username_max_length: 'Tên người dùng phải ít hơn 20 ký tự',
  com_auth_already_have_account: 'Đã có tài khoản?',
  com_auth_login: 'Đăng nhập',
  com_auth_reset_password: 'Đặt lại mật khẩu',
  com_auth_click: 'Nhấp chuột',
  com_auth_here: 'VÀO ĐÂY',
  com_auth_to_reset_your_password: 'để đặt lại mật khẩu của bạn.',
  com_auth_reset_password_link_sent: 'Email đã được gửi',
  com_auth_reset_password_email_sent:
    'Một email đã được gửi đến bạn với hướng dẫn chi tiết để đặt lại mật khẩu.',
  com_auth_error_reset_password:
    'Đã xảy ra sự cố khi đặt lại mật khẩu của bạn. Không tìm thấy người dùng nào với địa chỉ email đã cung cấp. Vui lòng thử lại.',
  com_auth_reset_password_success: 'Đặt lại mật khẩu thành công',
  com_auth_login_with_new_password: 'Bây giờ bạn có thể đăng nhập bằng mật khẩu mới của mình.',
  com_auth_error_invalid_reset_token: 'Mã đặt lại mật khẩu này không còn hợp lệ.',
  com_auth_click_here: 'Nhấp vào đây',
  com_auth_to_try_again: 'để thử lại.',
  com_auth_submit_registration: 'Gửi đăng ký',
  com_auth_welcome_back: 'Chào mừng trở lại',
  com_endpoint_open_menu: 'Mở Menu',
  com_endpoint_bing_enable_sydney: 'Bật Sydney',
  com_endpoint_bing_to_enable_sydney: 'Để bật Sydney',
  com_endpoint_bing_jailbreak: 'Bẻ khóa',
  com_endpoint_bing_context_placeholder:
    'Bing có thể sử dụng tối đa 7k mã thông báo cho \'ngữ cảnh\', mà nó có thể tham khảo trong cuộc trò chuyện. Giới hạn cụ thể không được biết nhưng có thể gặp lỗi vượt quá 7k mã thông báo',
  com_endpoint_bing_system_message_placeholder:
    'CẢNH BÁO: Sử dụng sai chức năng này có thể bị CẤM sử dụng Bing! Nhấp vào \'Thông điệp hệ thống\' để có hướng dẫn đầy đủ và thông điệp mặc định nếu không có (mặc định là \'Sydney\') được coi là an toàn.',
  com_endpoint_system_message: 'Thông điệp hệ thống',
  com_endpoint_default_blank: 'mặc định: trống',
  com_endpoint_default_false: 'mặc định: sai',
  com_endpoint_default_creative: 'mặc định: sáng tạo',
  com_endpoint_default_empty: 'mặc định: trống rỗng',
  com_endpoint_default_with_num: 'mặc định: {0}',
  com_endpoint_context: 'Ngữ cảnh',
  com_endpoint_tone_style: 'Phong cách nét',
  com_endpoint_token_count: 'Số mã thông báo',
  com_endpoint_output: 'Đầu ra',
  com_endpoint_google_temp:
    'Giá trị cao = ngẫu nhiên hơn, trong khi giá trị thấp = tập trung và xác định hơn. Chúng tôi khuyến nghị thay đổi giá trị này hoặc Top P nhưng không phải cả hai.',
  com_endpoint_google_topp:
    'Top-p thay đổi cách mô hình chọn mã thông báo để xuất. Mã thông báo được chọn từ căn cứ có xác suất cao nhất đến thấp nhất cho đến khi tổng xác suất của chúng bằng giá trị top-p.',
  com_endpoint_google_topk:
    'Top-k thay đổi cách mô hình chọn mã thông báo để xuất. Top-k là 1 có nghĩa là mã thông báo được chọn là phổ biến nhất trong tất cả các mã thông báo trong bảng từ vựng của mô hình (còn được gọi là giải mã tham lam), trong khi top-k là 3 có nghĩa là mã thông báo tiếp theo được chọn từ giữa 3 mã thông báo phổ biến nhất (sử dụng nhiệt độ).',
  com_endpoint_google_maxoutputtokens:
    'Số mã thông báo tối đa có thể được tạo ra trong phản hồi. Chỉ định một giá trị thấp hơn cho các phản hồi ngắn hơn và một giá trị cao hơn cho các phản hồi dài hơn.',
  com_endpoint_google_custom_name_placeholder: 'Đặt tên tùy chỉnh cho Google',
  com_endpoint_prompt_prefix_placeholder:
    'Đặt hướng dẫn hoặc ngữ cảnh tùy chỉnh. Bỏ qua nếu trống.',
  com_endpoint_custom_name: 'Tên tùy chỉnh',
  com_endpoint_prompt_prefix: 'Tiền tố',
  com_endpoint_temperature: 'Nhiệt độ',
  com_endpoint_default: 'mặc định',
  com_endpoint_top_p: 'Top P',
  com_endpoint_top_k: 'Top K',
  com_endpoint_max_output_tokens: 'Số mã thông báo tối đa',
  com_endpoint_openai_temp:
    'Giá trị cao = ngẫu nhiên hơn, trong khi giá trị thấp = tập trung và xác định hơn. Chúng tôi khuyến nghị thay đổi giá trị này hoặc Top P nhưng không phải cả hai.',
  com_endpoint_openai_max:
    'Số mã thông báo tối đa để tạo. Tổng chiều dài của mã thông báo đầu vào và mã thông báo đã tạo bị giới hạn bởi độ dài ngữ cảnh của mô hình.',
  com_endpoint_openai_topp:
    'Một phương pháp thay thế cho việc lấy mẫu nhiệt độ, được gọi là lấy mẫu ranh giới, nơi mô hình xem xét kết quả của các mã thông báo với khối lượng xác suất top_p. Vì vậy, giá trị 0.1 có nghĩa là chỉ các mã thông báo bao gồm 10% khối lượng xác suất top_p được xem xét. Chúng tôi khuyến nghị thay đổi giá trị này hoặc nhiệt độ nhưng không phải cả hai.',
  com_endpoint_openai_freq:
    'Số từ giữa -2.0 và 2.0. Giá trị dương trừu tượng hóa các mã thông báo mới dựa trên tần suất hiện có của chúng trong văn bản, làm giảm khả năng mô hình lặp lại cùng một dòng văn hoàn toàn.',
  com_endpoint_openai_pres:
    'Số từ giữa -2.0 và 2.0. Giá trị dương trừu tượng hóa mã thông báo mới dựa trên việc chúng có xuất hiện trong văn bản, làm tăng khả năng của mô hình để nói về các chủ đề mới.',
  com_endpoint_openai_custom_name_placeholder: 'Đặt tên tùy chỉnh cho ChatGPT',
  com_endpoint_openai_prompt_prefix_placeholder:
    'Đặt hướng dẫn tùy chỉnh để bao gồm vào Thông điệp hệ thống. Mặc định: không có',
  com_endpoint_anthropic_temp:
    'Các giá trị nằm trong khoảng từ 0 đến 1. Sử dụng nhiệt độ gần 0 cho các nhiệm vụ phân tích / lựa chọn nhiều lựa chọn, và gần 1 cho các nhiệm vụ sáng tạo và tạo ra. Chúng tôi khuyến nghị thay đổi giá trị này hoặc Top P nhưng không phải cả hai.',
  com_endpoint_anthropic_topp:
    'Top-p thay đổi cách mô hình chọn mã thông báo để xuất. Mã thông báo được chọn từ căn cứ có xác suất cao nhất đến thấp nhất cho đến khi tổng xác suất của chúng bằng giá trị top-p.',
  com_endpoint_anthropic_topk:
    'Top-k thay đổi cách mô hình chọn mã thông báo để xuất. Top-k là 1 có nghĩa là mã thông báo được chọn là phổ biến nhất trong tất cả các mã thông báo trong bảng từ vựng của mô hình (còn được gọi là giải mã tham lam), trong khi top-k là 3 có nghĩa là mã thông báo tiếp theo được chọn từ giữa 3 mã thông báo phổ biến nhất (sử dụng nhiệt độ).',
  com_endpoint_anthropic_maxoutputtokens:
    'Số mã thông báo tối đa có thể được tạo ra trong phản hồi. Chỉ định một giá trị thấp hơn cho các phản hồi ngắn hơn và một giá trị cao hơn cho các phản hồi dài hơn.',
  com_endpoint_anthropic_custom_name_placeholder: 'Đặt tên tùy chỉnh cho Anthropic',
  com_endpoint_frequency_penalty: 'Hình phạt tần suất',
  com_endpoint_presence_penalty: 'Hình phạt hiện diện',
  com_endpoint_plug_use_functions: 'Sử dụng chức năng',
  com_endpoint_plug_skip_completion: 'Bỏ qua hoàn thành',
  com_endpoint_disabled_with_tools: 'bị vô hiệu hóa với các công cụ',
  com_endpoint_disabled_with_tools_placeholder: 'Bị vô hiệu hóa với các công cụ đã chọn',
  com_endpoint_plug_set_custom_instructions_for_gpt_placeholder:
    'Đặt hướng dẫn tùy chỉnh để bao gồm trong Thông điệp hệ thống. Mặc định: không có',
  com_endpoint_import: 'Nhập',
  com_endpoint_set_custom_name: 'Đặt tên tùy chỉnh, nếu bạn có thể tìm thấy cài đặt này',
  com_endpoint_preset: 'đặt sẵn',
  com_endpoint_presets: 'đặt sẵn',
  com_endpoint_preset_name: 'Tên đặt sẵn',
  com_endpoint_new_topic: 'Chủ đề mới',
  com_endpoint: 'Điểm kết thúc',
  com_endpoint_hide: 'Ẩn',
  com_endpoint_show: 'Hiển thị',
  com_endpoint_examples: ' Đặt sẵn',
  com_endpoint_completion: 'Hoàn thành',
  com_endpoint_agent: 'Đặc trưng',
  com_endpoint_show_what_settings: 'Hiển thị cài đặt {0}',
  com_endpoint_save: 'Lưu',
  com_endpoint_export: 'Xuất',
  com_endpoint_save_as_preset: 'Lưu dưới dạng đặt sẵn',
  com_endpoint_presets_clear_warning:
    'Bạn có chắc chắn muốn xóa tất cả các đặt sẵn? Hành động này không thể hoàn tác.',
  com_endpoint_not_implemented: 'Chưa thực hiện',
  com_endpoint_no_presets: 'Chưa có đặt sẵn',
  com_endpoint_not_available: 'Không có điểm kết thúc nào khả dụng',
  com_endpoint_view_options: 'Xem tùy chọn',
  com_endpoint_save_convo_as_preset: 'Lưu cuộc trò chuyện dưới dạng đặt sẵn',
  com_endpoint_my_preset: 'Đặt sẵn của tôi',
  com_endpoint_agent_model: 'Mô hình Đặc trưng (Đề xuất: GPT-3.5)',
  com_endpoint_completion_model: 'Mô hình Hoàn thành (Đề xuất: GPT-4)',
  com_endpoint_func_hover: 'Cho phép sử dụng Plugin như các chức năng OpenAI',
  com_endpoint_skip_hover:
    'Cho phép bỏ qua bước hoàn thành, kiểm tra câu trả lời cuối cùng và các bước đã tạo',
  com_endpoint_config_key: 'Đặt Khóa API',
  com_endpoint_config_key_for: 'Đặt Khóa API cho',
  com_endpoint_config_key_name: 'Khóa',
  com_endpoint_config_value: 'Nhập giá trị cho',
  com_endpoint_config_key_name_placeholder: 'Đặt khóa API trước',
  com_endpoint_config_key_encryption: 'Khóa của bạn sẽ được mã hóa và xóa vào lúc',
  com_endpoint_config_key_expiry: 'thời gian hết hạn',
  com_endpoint_config_key_import_json_key: 'Nhập Khóa JSON Tài khoản Dịch vụ.',
  com_endpoint_config_key_import_json_key_success: 'Nhập thành công Khóa JSON Tài khoản Dịch vụ',
  com_endpoint_config_key_import_json_key_invalid:
    'Khóa JSON Tài khoản Dịch vụ không hợp lệ, Bạn đã nhập đúng tệp không?',
  com_endpoint_config_key_get_edge_key: 'Để nhận Mã truy cập Bing của bạn, đăng nhập vào',
  com_endpoint_config_key_get_edge_key_dev_tool:
    'Sử dụng các công cụ phát triển hoặc tiện ích mở rộng trong khi đăng nhập vào trang web để sao chép nội dung của cookie _U. Nếu không thành công, làm theo',
  com_endpoint_config_key_edge_instructions: 'hướng dẫn',
  com_endpoint_config_key_edge_full_key_string: 'để cung cấp chuỗi cookie đầy đủ.',
  com_endpoint_config_key_chatgpt:
    'Để nhận Mã truy cập của bạn cho ChatGPT \'Phiên bản miễn phí\', đăng nhập vào',
  com_endpoint_config_key_chatgpt_then_visit: 'sau đó truy cập',
  com_endpoint_config_key_chatgpt_copy_token: 'Sao chép mã truy cập.',
  com_endpoint_config_key_google_need_to: 'Bạn cần',
  com_endpoint_config_key_google_vertex_ai: 'Bật Vertex AI',
  com_endpoint_config_key_google_vertex_api: 'API trên Google Cloud, sau đó',
  com_endpoint_config_key_google_service_account: 'Tạo một Tài khoản Dịch vụ',
  com_endpoint_config_key_google_vertex_api_role:
    'Hãy chắc chắn nhấp vào \'Tạo và Tiếp tục\' để cấp ít nhất vai trò \'Người dùng Vertex AI\' thì còn lại, tạo một khóa JSON để nhập vào đây.',
  com_nav_auto_scroll: 'Cuộn tự động đến tin nhắn mới nhất khi mở',
  com_nav_plugin_store: 'Cửa hàng Plugin',
  com_nav_plugin_search: 'Tìm kiếm plugin',
  com_nav_plugin_auth_error: 'Đã xảy ra lỗi khi xác thực plugin này. Vui lòng thử lại.',
  com_nav_export_filename: 'Tên tệp',
  com_nav_export_filename_placeholder: 'Đặt tên cho tệp',
  com_nav_export_type: 'Loại',
  com_nav_export_include_endpoint_options: 'Bao gồm các tùy chọn điểm kết thúc',
  com_nav_enabled: 'Đã bật',
  com_nav_not_supported: 'Không được hỗ trợ',
  com_nav_export_all_message_branches: 'Xuất tất cả các nhánh tin nhắn',
  com_nav_export_recursive_or_sequential: 'Đệ quy hay tuần tự?',
  com_nav_export_recursive: 'Đệ quy',
  com_nav_export_conversation: 'Xuất cuộc trò chuyện',
  com_nav_export: 'Xuất',
  com_nav_shared_links: 'Liên kết được chia sẻ',
  com_nav_shared_links_manage: 'Quản l',
  com_nav_shared_links_empty: 'Bạn không có link được chia sẻ.',
  com_nav_shared_links_name: 'Tên',
  com_nav_shared_links_date_shared: 'Ngày chia sẻ',
  com_nav_theme: 'Chủ đề',
  com_nav_theme_system: 'Hệ thống',
  com_nav_theme_dark: 'Tối',
  com_nav_theme_light: 'Sáng',
  com_nav_font_size: 'Cỡ chữ',
  com_nav_clear_all_chats: 'Xóa tất cả cuộc trò chuyện',
  com_nav_confirm_clear: 'Xác nhận xóa',
  com_nav_close_sidebar: 'Đóng thanh bên',
  com_nav_open_sidebar: 'Mở thanh bên',
  com_nav_send_message: 'Gửi tin nhắn',
  com_nav_log_out: 'Đăng xuất',
  com_nav_user: 'NGƯỜI DÙNG',
  com_nav_clear_conversation: 'Xóa cuộc trò chuyện',
  com_nav_clear_conversation_confirm_message:
    'Bạn có chắc chắn muốn xóa tất cả cuộc trò chuyện? Hành động này không thể hoàn tác.',
  com_nav_help_faq: 'Trợ giúp & Câu hỏi thường gặp',
  com_nav_settings: 'Cài đặt',
  com_nav_search_placeholder: 'Tìm kiếm tin nhắn',
  com_nav_info_bookmarks_rebuild:
    'Nếu số lượng dấu trang không chính xác, vui lòng xây dựng lại thông tin dấu trang. Số lượng dấu trang sẽ được tính lại và dữ liệu sẽ được khôi phục về trạng thái chính xác.',
  com_nav_setting_general: 'Chung',
  com_nav_setting_data: 'Kiểm soát dữ liệu',
  com_nav_lang_english: 'English',
  com_nav_lang_chinese: '中文',
  com_nav_lang_german: 'Deutsch',
  com_nav_lang_spanish: 'Español',
  com_nav_lang_french: 'Français ',
  com_nav_lang_italian: 'Italiano',
  com_nav_lang_polish: 'Polski',
  com_nav_lang_brazilian_portuguese: 'Português Brasileiro',
  com_nav_lang_russian: 'Русский',
  com_nav_lang_japanese: '日本語',
  com_nav_lang_swedish: 'Svenska',
  com_nav_lang_korean: '한국어',
  com_nav_lang_vietnamese: 'Tiếng Việt',
  com_nav_lang_traditionalchinese: '繁體中文',
  com_nav_lang_arabic: 'العربية',
  com_nav_lang_turkish: 'Türkçe',
  com_nav_lang_dutch: 'Nederlands',
  com_nav_lang_indonesia: 'Indonesia',
  com_nav_lang_hebrew: 'עברית',
  com_nav_lang_finnish: 'Suomi',
};
